<script lang="ts" setup>
import type { StrapiRespMulti } from '~/models/Strapi'

const config = useRuntimeConfig()
const route = useRoute()
const strapiData = ref()

getStrapi(useStrapiLocale(useGetSubdomain(), null))
async function getStrapi(lang: string) {
  const { data, error } = await useStrapiAPI<StrapiRespMulti>(`/pages?filters[page_type][$eq]=faq&populate[meta]=*&populate[contents]=*&publicationState=live&locale=${lang}`, {
    key: 'get_faq',
    initialCache: false,
  })
  if (!isEmpty(data.value?.data)) {
    strapiData.value = data.value.data[0]?.attributes
    setMeta(strapiData.value.meta)
  }
  else { throw showError({ statusCode: 404, statusMessage: 'Page Not Found' }) }
}

function setMeta(metaVal: any) {
// seo
  const seoTitle = metaVal?.title || ''
  const seoDescription = metaVal?.description || ''
  const keywords = metaVal?.keywords || ''
  const robots = (config.public.ENV === 'development' || config.public.ENV === 'staging') ? 'nofollow, noindex' : (metaVal?.robots || 'follow, index')
  const canonical = metaVal?.canonical || useSetSubdomain(useGetSubdomain()) + route.path

  useHead({
    title: seoTitle,
    meta: [
      { property: 'og:title', content: seoTitle },
      { name: 'twitter:title', content: seoTitle },
      { name: 'description', content: seoDescription },
      { property: 'og:description', content: seoDescription },
      { name: 'twitter:description', content: seoDescription },
      { name: 'keywords', content: keywords || null },
      robots ? { name: 'robots', content: robots } : {},
    ],
    link: [
      canonical && { rel: 'canonical', href: canonical },
    ],
  })
}
</script>

<template>
  <BaseAtomsSkeletonBounded class="max-w-6xl !px-4 !lg:px-8 bg-white !py-10 !mt-10 rounded-md" container="full">
    <div v-for="(item, idx) in strapiData?.contents" :key="idx">
      <component :is="useStrapiComponent(item.__component)" :datas="item" />
    </div>
  </BaseAtomsSkeletonBounded>
</template>
